<div class="card wd">
<form class="center">
    <h1>User Creation</h1>
</form>


<div class="col-md-6 FormAllaign">
<div class="form-group">
       <div class="d-flex justify-content-end">
        <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
            Add Attendance
          </button>
       </div>
    <div class="form-group">
        <label>User Name</label><span class="error">{{username}}</span>
        <input type="text" class="form-control" placeholder="User name" name="username" [(ngModel)]="data.username"  (ngModelChange)="valuechange1($event)">
    </div>
</div>
        
    <div class="form-group">
        <div class="form-group">
            <label>Password</label> <span class="error">{{password}}</span>
            <div class="password-input-wrapper">
                <input [type]="showPassword ? 'text' : 'password'" class="form-control"  placeholder="password" name="password" [(ngModel)]="data.password"  (ngModelChange)="valuechange2($event)">
                <span class="password-toggle-icon" (click)="togglePasswordVisibility()">
                    <i [class]="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                </span>
            </div>
        </div>
    </div>
    
    <div class="form-group">
        <div class="form-group">
            <label>Confirm Password</label><!--<span class="error">{{C_password}}</span>--><span class="error">{{doesntMatch}}</span>
            <div class="password-input-wrapper">
                <input [type]="showConfirmPassword ? 'text' : 'password'" class="form-control"  placeholder="Confirm password" name="Cpassword" [(ngModel)]="data.conformpassword"  (ngModelChange)="valuechange3($event)" >
                <span class="password-toggle-icon" (click)="toggleConfirmPasswordVisibility()">
                    <i [class]="showConfirmPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                </span>
            </div>
        </div>
    
           
     <div class="form-group">
        <div class="form-group">
            <label>User type</label><span class="error">{{emp_type}}</span>
        
    <select  class="form-control select2 select2-hidden-accessible" style="width: 100%;" data-select2-id="1" tabindex="-1" aria-hidden="true" [(ngModel)]="data.usertype" (ngModelChange)="valuechange5($event)">
        <option *ngFor="let item of userTypedropdown">{{item.name}}</option>
    </select>
    <!-- <select  class="form-control select2 select2-hidden-accessible" style="width: 100%;" data-select2-id="1" tabindex="-1" aria-hidden="true" [(ngModel)]="data.usertype" (ngModelChange)="valuechange5($event)">
        <option>Admin</option>
        <option>Employee</option>
        <option>Factory_Manager</option>
        <option>Delivery_Man</option>
        <option>Manager</option>
        <option>Salesman</option>
        <option>Marketing</option>
        <option>Sales_Promoter</option>
        <option>Manager_Pro</option>
        <option>Department_Foreman</option>
        <option>Technician</option>
        <option>Helper</option>
        <option>Mixer</option>
        <option>BDM</option>
        <option>Sales_Executive</option>
        <option>Driver</option>
        <option>UAE_Wholesale_Salesman</option>
        <option>Qc_Chemist</option>
        <option>Admin_Operations</option>
        <option>Operations_Manager</option>
        <option>Hr_Manager</option>
        <option>Credit_Manager</option>
        <option>Finance_Manager</option>
        <option>Crm_Admin</option>
        <option>KSA_Salesman</option>
        <option>KSA_Foreman</option>
        <option>KSA_Helper</option>
        <option>KSA_wholesale_salesman</option>
        <option>Oman_wholesale_salesman</option>
        <option>Oman_salesman</option>
        <option>FG_dispatch</option>
        <option>factory_data_entry</option>
    </select> -->

        </div>
     <!-- Replace this section in your HTML -->
<div class="form-group">
    <div class="form-group">
        <label>Select Employee</label><span class="error">{{Search_employee}}</span>
     
    <div class="input-group search-input-group">
        <input type="search" class="form-control" placeholder="Search employee" [(ngModel)]="data.employee_name" (ngModelChange)="valuechange4($event);SearchEmployee();">
        <button type="button" class="btn btn-search" (click)="SearchEmployee();">
            <i class="fa fa-search"></i>
        </button>
    </div>

    <div class="card card-default employee-dropdown" *ngIf="isShownEmployee">
        <div *ngFor="let c of employee">
            <h4 class="font" (click)="getEmployeeId(c.employee_id,c.employee_name)">
                <b>{{c.employee_name}}</b>
            </h4>
        </div>
    </div>
</div>
        </div>
         <!-------------------Test alert---------------------->
         <!-- <div class="alert alert-success alert-dismissible alertWidth" *ngIf="isShown">
            <button type="button" class="close" data-dismiss="alert" aria-hidden="true" (click)="shown()">×</button>
            <h4><i class="icon fas fa-check"></i> {{alert}}</h4>
             
            </div> -->
        <!---------------------------------------
        <div class="sucess" *ngIf="isShown">
            <span class="closebtn content" onclick="this.parentElement.style.display='none';">&times;</span> 
            {{alert}}
          </div><br>
--->
        <button type="submit" class="btn btn-success btn_allign" (click)="Create();">Create</button>

</div>



<!-- Button trigger modal -->

  
  <!-- Modal -->
  <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Attendance Management</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
            <div class="card-body">







                <form class="form-data" [formGroup]="creationForm" >
                    <!-- <div class="d-flex justify-content-end ">
                        <button type="submit" class="submit">Submit</button>
                    </div> -->
                    <section class="main-page-box">
                        <div class="row">
                            <div class="col-12 col-sm-8 col-md-6">
                                <div class="row">
                                    <div class="col-12">
                                        <label for="workin_time" class="required">Work in time</label>
                                        <input class="form-control" name="workin_time" type="time" id="workin_time"
                                        formControlName="workin_time">
                                        <div *ngIf="creationForm.get('workin_time')?.invalid && creationForm.get('workin_time')?.touched"
                                            class="text-danger">
                                            Work In Time is required
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <label for="is_department_specific" class="required">Is department Specific</label>
                                        <input class="form" type="checkbox" value="" id="is_department_specific" name="is_department_specific" formControlName="is_department_specific" >
                                        <div *ngIf="creationForm.get('is_department_specific')?.invalid && creationForm.get('is_department_specific')?.touched"
                                            class="text-danger">
                                            Department Specific is Required
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <label for="is_location_restricted" class="required">Weekly Working Day</label>
                                        <div *ngFor="let day of weeKDays; let i = index">
                                            <mat-checkbox [checked]="day.checked" (change)="weekSelected(i+1)">
                                              {{ day.week }}
                                            </mat-checkbox>
                                          </div>                               
                                    </div>
                                </div>
        
        
                            </div>
                            <div class="col-12 col-sm-8 col-md-6">
                                <div class="row">
                                   
                                    <div class="col-12">
                                        <label for="workout_time" class="required">Work out time</label>
                                        <input  class="form-control" type="time"
                                            name="workout_time" id="workout_time" formControlName="workout_time">
                                        <div *ngIf="creationForm.get('workout_time')?.invalid && creationForm.get('workout_time')?.touched"
                                            class="text-danger">
                                             Work out time is Required
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <label for="is_location_restricted" class="required">Is location restricted</label>
                                        <input class="form" type="checkbox" value="" id="is_location_restricted" name="is_location_restricted" formControlName="is_location_restricted" >
                                        <div *ngIf="creationForm.get('is_location_restricted')?.invalid && creationForm.get('is_location_restricted')?.touched"
                                            class="text-danger">
                                            Location Specific Required
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <label for="is_visit_location_restricted" class="required">Is visit location restricted</label>
                                        <input class="form" type="checkbox" value="" id="is_visit_location_restricted" name="is_visit_location_restricted" formControlName="is_visit_location_restricted" >
                                        <div *ngIf="creationForm.get('is_visit_location_restricted')?.invalid && creationForm.get('is_visit_location_restricted')?.touched"
                                            class="text-danger">
                                            Location Specific Required
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <label for="is_customer_location_enabled" class="required boxcheck">Is Customer Location Enabled</label>
                                        <input class="form" type="checkbox" value="" id="is_customer_location_enabled" name="is_customer_location_enabled" formControlName="is_customer_location_enabled" >
                                        <div *ngIf="creationForm.get('is_customer_location_enabled')?.invalid && creationForm.get('is_customer_location_enabled')?.touched"
                                            class="text-danger">
                                            Customer location Required
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <label for="factory_department_id" class="required boxcheck">Factory Department</label>
                                        <!-- <input class="form-control" type="text" value="" id="factory_department_id" name="factory_department_id" formControlName="factory_department_id" > -->
                                        <ng-select
                                        [items]="factoryDepartmentdropdown"
                                        bindLabel="name"
                                        bindValue="_id"
                                        name="factory_department_id"
                                        id="factory_department_id"
                                        formControlName="factory_department_id"
                                      ></ng-select>
                                        <div *ngIf="creationForm.get('factory_department_id')?.invalid && creationForm.get('factory_department_id')?.touched"
                                            class="text-danger">
                                            Factory department Required
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </form>
            </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary" (click)="attendanceData()" data-bs-dismiss="modal">Save changes</button>
        </div>
      </div>
    </div>
  </div>

<!-- Toast Container -->
<div class="toast-container-custom" *ngIf="toastMessage">
  <div class="toast-custom" [ngClass]="toastType">
    <div class="toast-icon-custom">
      <i [class]="toastType === 'success' ? 'fa fa-check' : 'fa fa-times'"></i>
    </div>
    <div class="toast-content-custom">
      <p class="toast-message-custom">{{ toastMessage }}</p>
    </div>
  </div>
</div>